// Angular Files
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { RouterModule } from '@angular/router';

// Component
import { PublicPortalWelcomeComponent } from './public-portal-welcome.component';

// Directives
import { DirectivesModule } from '../../../directives/directives.module';

// Edit Controls
import { EditControlsModule } from '../../edit-controls/edit-controls.module';

@NgModule({
    declarations: [
        PublicPortalWelcomeComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        MatButtonModule,
        MatCardModule,
        MatIconModule,
        MatListModule,
        MatMenuModule,
        DirectivesModule,
        EditControlsModule
    ],
    exports: [
        PublicPortalWelcomeComponent
    ]
})
export class PublicPortalWelcomeModule { }